module.exports = __webpack_public_path__ + "img/DieBurg.aa878dd7.jpg";